import { AbstractEntity } from "../AbstractEntity";
export default class FlagState extends AbstractEntity {
    flagRegistrationDate;
    flagState;
    ceaseDateOfFlagstateRegistration;
    constructor(flagRegistrationDate, flagState, ceaseDateOfFlagstateRegistration) {
        super();
        this.flagRegistrationDate = flagRegistrationDate;
        this.flagState = flagState;
        this.ceaseDateOfFlagstateRegistration = ceaseDateOfFlagstateRegistration;
    }
}
//# sourceMappingURL=FlagState.js.map